<template>
  <div>
    <template v-if="change_content == 1">
      <div class="statusBox status0">
        <div class="statusBox_text">
          <div>
            发布时间及场地由组委会根据本季时装周整体情况统筹安排，具体发布时间及场地将由组委会另行通知，
            经品牌方确认后签署协议并交纳发布费尾款。
          </div>
        </div>
      </div>
    </template>
    <template v-if="change_content == 2">
      <!--<div class="title_text">秀场介绍</div>-->
      <h4>秀场介绍</h4>
      <div class="title_content">
        中国国际时装周创立于1997年，每年3月和9月分春夏和秋冬两季在北京举办，活动内容由专场发布、设计大赛、专项展览、专题论坛、专业评选等主要业务单元组成。经过23年的发展与完善，中国国际时装周现已成为中外知名时装、成衣及配饰品牌展示新设计、新产品、新技术的主流渠道和国家窗口，成为时尚品牌和设计师形象推广、市场开拓、商品交易、流行传播、专业评价的国际化综合服务平台。截至目前，已有来自中国（含港澳台）、日本、韩国、泰国、新加坡、法国、意大利、美国、俄罗斯、瑞士、德国、荷兰、瑞典、丹麦、英国、澳大利亚等近30个国家和地区的830余位设计师、810余家品牌和机构举办了1636场发布会，每季中国国际时装周都吸引数百家中外媒体参与采访报道。
      </div>
      <div class="line_"></div>
      <div v-if="Order_detail.status == 2">
        <h4>选场结果</h4>
        <el-row :gutter="24" style="margin: 30px 100px">
          <el-col :span="12">
            <div>
              <span>场地：</span>
              <span
                >{{
                  Order_detail.declare_items_site_time_info.position.name +
                  Order_detail.declare_items_site_time_info.site_time.name
                }}
              </span>
            </div>
          </el-col>
          <el-col :span="6">
            <div v-if="Order_detail.declare_items_info.award_introduction">
              <span
                class="introduce_box"
                @click="See(Order_detail.declare_items_info.award_introduction)"
              >
                查看场馆介绍</span
              >
            </div>
          </el-col>
          <el-col :span="6">
            <div style="text-align: end">
              <span>金额：</span>
              <span style="color: #ff4d4f"
                >￥{{
                  Order_detail.declare_items_site_time_info.site_time.price
                }}</span
              >
            </div>
          </el-col>
        </el-row>
      </div>
      <div v-else>
        <div>
          <h4>选场意愿</h4>
          <el-form
            :inline="true"
            :model="wishForm"
            :rules="wishForm_rules"
            ref="wishFormRef"
            :disabled="Order_detail.status != 0 && Order_detail.status != 9"
            label-position="top"
          >
            <el-row :gutter="24">
              <el-col :span="12">
                <!-- <div style="color:#666666">意愿一</div>-->
                <el-form-item label="场地选择 (意愿一):" prop="wish_1">
                  <el-cascader
                    :props="cascader_props"
                    v-model="wishForm.wish_1"
                    :options="options"
                    clearable
                    @change="handleChange(1, wishForm.wish_1)"
                    @expand-change="handleExpandChange"
                  >
                    <template slot="empty">
                      <div class="custom-empty">
                        <li class="el-cascader__empty-text">123</li>
                      </div>
                    </template>
                  </el-cascader>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <div style="text-align: end">
                  <span>金额：</span>
                  <span style="color: #ff4d4f">￥{{ wishForm.price_1 }}</span>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <!-- <div style="color:#666666">意愿一</div>-->
                <el-form-item label="场地选择 (意愿二):">
                  <el-cascader
                    :props="cascader_props"
                    v-model="wishForm.wish_2"
                    :options="options"
                    clearable
                    @change="handleChange(2, wishForm.wish_2)"
                  >
                  </el-cascader>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <div style="text-align: end">
                  <span>金额：</span>
                  <span style="color: #ff4d4f">￥{{ wishForm.price_2 }}</span>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <!-- <div style="color:#666666">意愿一</div>-->
                <el-form-item label="场地选择 (意愿三):">
                  <el-cascader
                    :props="cascader_props"
                    v-model="wishForm.wish_3"
                    :options="options"
                    clearable
                    @change="handleChange(3, wishForm.wish_3)"
                  >
                  </el-cascader>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <div style="text-align: end">
                  <span>金额：</span>
                  <span style="color: #ff4d4f">￥{{ wishForm.price_3 }}</span>
                </div>
              </el-col>
            </el-row>
          </el-form>
          <!-- <div class="line_"></div> -->
        </div>

        <div v-if="introduceArr.length !== 0">
          <h4>专场发布场馆介绍</h4>
          <div class="bottom_box">
            <span
              class="introduce_box"
              v-for="(item, index) in introduceArr"
              :key="index"
              @click="downSee(item)"
            >
              <span
                v-if="item.introduce && item.introduce != ''"
                class="el-icon-download"
              ></span>
              <span v-if="item.introduce && item.introduce != ''">{{
                item.name
              }}</span>
            </span>
          </div>
        </div>
      </div>
      <div class="line_"></div>
      <h4>请品牌方填写邮寄地址，用于组委会寄出合同</h4>
      <el-form
        :model="formData"
        :rules="formData_rules"
        ref="formDataRef"
        :disabled="Order_detail.status != 0 && Order_detail.status != 9"
        label-position="top"
      >
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="联系人:" prop="brand_contacts">
              <el-input
                type="text"
                v-model="formData.brand_contacts"
                auto-complete="off"
                placeholder="请输入联系人"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系电话:" prop="brand_mobile">
              <el-input
                type="text"
                v-model="formData.brand_mobile"
                auto-complete="off"
                placeholder="请输入联系电话"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="详细地址:" prop="brand_address">
              <el-input
                maxlength="100"
                show-word-limit
                v-model="formData.brand_address"
                type="textarea"
                rows="4"
                clearable
                placeholder="请输入详细地址"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <!--        <div style="margin-top: 10px;">-->
        <!--          <button class="btn_ " @click="save">保存信息</button>-->
        <!--        </div>-->
      </el-form>
      <div class="footer" style="margin-top: 100px">
        <button
          v-if="Order_detail.status == 0"
          class="btn next_btn"
          @click="next"
        >
          下一步
        </button>
        <button v-else class="btn next_btn" @click="to_next">下一步</button>
      </div>
    </template>
    <template v-if="change_content == 3">
      <toExamine :to_examine_form="to_examine_form"></toExamine>
    </template>
  </div>
</template>

<script>
import { declareOrder_add, declareOrder_detail, siteLists } from "@/api/api";
import toExamine from "@/views/examine.vue";

export default {
  components: { toExamine },
  props: [],
  name: "selectionIntention",
  data() {
    return {
      to_examine_form: {
        //
        // 1待审核  2成功  3驳回
        audit_status: 1, //审核状态
        review_text1:
          "发布时间及场地由组委会根据本季时装周整体情况统筹安排，具体发布时间及场地将由组委会另行通知，经品牌方确认后签署协议并交纳发布费尾款。", //待审核文案
        review_text2: "已确认", //成功文案
        review_text3: "驳回", //驳回文案
      },
      cascader_props: { label: "name", value: "id", children: "site_time" },
      wishForm: {
        wish_1: [],
        price_1: 0,
        wish_2: [],
        price_2: 0,
        wish_3: [],
        price_3: 0,
      }, //
      change_content: 0,
      countdown: 5, //计时器
      countdown_show: true, //计时器
      headers: {
        token: localStorage.getItem("token"),
      },
      wishForm_rules: {
        wish_1: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
      },
      options: [],
      Order_detail: {},
      introduceArr: [],
      formData: {
        brand_contacts: "",
        brand_mobile: "",
        brand_address: "",
      },
      formData_rules: {
        brand_contacts: [
          { required: true, message: "请输入", trigger: ["blur"] },
        ],
        brand_mobile: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "手机号码格式不正确",
            trigger: "blur",
          },
        ],
        brand_address: [
          { required: true, message: "请输入", trigger: ["blur"] },
        ],
      },
    };
  },
  mounted() {
    this.init();
  },
  created() {},
  watch: {},
  methods: {
    async init() {
      let declare_items_id = JSON.parse(localStorage.getItem("theSession")).id;
      let datas = this.$qs.stringify({
        declare_items_id: declare_items_id,
        page_type: 0,
      });
      const ress = await siteLists(datas);
      if (ress.code == 1) {
        let arr = ress.data.lists;
        arr.forEach((item) => {
          // console.log(item);
        });
        this.options = ress.data.lists;
        this.handleChange();
      }

      let data = this.$qs.stringify({
        declare_items_id: declare_items_id,
      });
      const res = await declareOrder_detail(data);
      this.Order_detail = res.data;
      this.formData.brand_contacts = res.data.brand_contacts;
      this.formData.brand_mobile = res.data.brand_mobile;
      this.formData.brand_address = res.data.brand_address;
      if (this.Order_detail.status == 0 || this.Order_detail.status == 9) {
        this.handleCascaderItemHidden();
      }
      if (this.Order_detail.status == 1 || this.Order_detail.status == 2) {
        this.change_content = 3;
      } else {
        this.change_content = ress.data.lists.length > 0 ? 2 : 1;
      }
      this.to_examine_form.audit_status = this.Order_detail.status;
      if (this.Order_detail.status != 9) {
        for (let i = 1; i <= 3; i++) {
          if (i > res.data.declare_site_info.length) {
            this.wishForm["price_" + i] = 0;
            this.wishForm["wish_" + i] = [];
          } else {
            this.introduceArr = [];
            this.introduceArr.push({
              type: i,
              introduce: res.data.declare_site_info[i - 1].position.introduce,
              name: res.data.declare_site_info[i - 1].position.name,
            });
            this.wishForm["price_" + i] =
              res.data.declare_site_info[i - 1].site_time.price;
            this.wishForm["wish_" + i] = res.data.declare_site_info[
              i - 1
            ].wish_.map((item) => Number(item));
          }
        }
      }
      // this.get_siteLists()
    },
    handleCascaderItemHidden() {
      let arr = this.options;
      for (let i = 0; i < arr.length; i++) {
        for (let j = 0; j < arr[i].site_time.length; j++) {
          if (
            arr[i].site_time[j].stataus == 2 ||
            arr[i].site_time[j].stataus == 3
          ) {
            // delete arr[i].site_time[j];
            arr[i].site_time.splice(j, 1);
          }
        }
      }
      this.options = arr;
    },
    // 获取场地
    async get_siteLists() {
      let data = this.$qs.stringify({
        declare_items_id: JSON.parse(localStorage.getItem("theSession")).id,
        page_type: 0,
      });
      const res = await siteLists(data);
      if (res.code == 1) {
        this.change_content =
          this.Order_detail.status == 9 ? 9 : res.data.lists.length > 0 ? 2 : 1;
        this.options = res.data.lists;
        this.handleChange();
      }
    },

    handleChange(type, num) {
      if (num && num.length == 0) {
        this.wishForm["price_" + type] = 0;
        this.introduceArr.forEach((item, index) => {
          if (item.type == type) {
            this.introduceArr.splice(index, 1);
          }
        });
      } else if (num && num.length == 2) {
        this.options.forEach((item, index) => {
          item.site_time.forEach((child) => {
            if (num[1] == child.id) {
              this.wishForm["price_" + type] = child.price;
              let middle = this.introduceArr.some((items) => {
                return items.type == type;
              });
              if (middle) {
                this.introduceArr.forEach((items, indexs) => {
                  if (items.type == type) {
                    this.introduceArr.splice(indexs, 1, {
                      type: type,
                      introduce: item.introduce,
                      name: item.name,
                    });
                  }
                });
              } else {
                this.introduceArr.push({
                  type: type,
                  introduce: item.introduce,
                  name: item.name,
                });
              }
            }
          });
        });
      }
      let brandArr = [
        this.wishForm.wish_1[1],
        this.wishForm.wish_2[1],
        this.wishForm.wish_3[1],
      ];
      let arr = JSON.parse(JSON.stringify(this.options));
      arr.forEach((item) => {
        item.disabled = false;
        if (item.site_time) {
          item.site_time.forEach((child) => {
            child.disabled = false; // 默认不禁用所有子选项
          });
        }
      });
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].site_time.length > 0) {
          arr[i].site_time.forEach((items) => {
            if (brandArr.indexOf(items.id) !== -1) {
              items.disabled = true;
            }
          });
        }
      }
      this.options = [];
      this.options = JSON.parse(JSON.stringify(arr));
    },
    handleExpandChange(data) {
      this.options.forEach((item) => {
        if (item.id == data[0]) {
          if (
            item.site_time.length == 0 ||
            (item.site_time.length > 0 && item.site_time[0] === undefined)
          ) {
            this.$nextTick(() => {
              const cascaderElement = document.querySelector(
                ".el-cascader-menu__empty-text"
              );
              cascaderElement.style.width = "90%";
              cascaderElement.style.lineHeight = "24px";
              cascaderElement.innerHTML = "该场地暂无可选时间段,请查看其他场地";
            });
          }
        }
      });
    },

    downSee(item) {
      window.open(item.introduce, "_blank");
    },
    See(item) {
      window.open(item, "_blank");
    },
    to_next() {
      if (this.Order_detail.status != 2) {
        this.change_content = 3;
      } else {
        this.$parent.to_next();
      }
    },
    save() {
      let type = null;
      this.$refs["formDataRef"].validate((valid) => {
        type = valid;
      });
      return type;
    },
    // 赵
    next() {
      this.$refs["wishFormRef"].validate(async (valid) => {
        if (valid) {
          let valids = await this.save();
          if (!valids) return;
          let declare_site_info = [];
          for (let i = 1; i <= 3; i++) {
            this.options.forEach((item) => {
              if (item.id == this.wishForm["wish_" + i][0]) {
                item.site_time.forEach((items) => {
                  if (items.id == this.wishForm["wish_" + i][1]) {
                    declare_site_info.push({
                      wish_: this.wishForm["wish_" + i],
                      position: item,
                      site_time: items,
                    });
                  }
                });
              }
            });
          }

          let data = {
            order_no: this.Order_detail.order_no,
            declare_site_info: declare_site_info,
            brand_contacts: this.formData.brand_contacts,
            brand_mobile: this.formData.brand_mobile,
            brand_address: this.formData.brand_address,
          };
          const res = await declareOrder_add(data);
          if (res.code == 1) {
            this.$message.success(res.msg);
            this.init();
          } else {
            this.$message.error(res.msg);
          }
        }
      });
    },
    change_contentShow() {
      this.change_content = 2;
    },

    // 计时器
    timer() {
      if (this.countdown < 0) {
        this.countdown = 5;
        this.countdown_show = false;
        return;
      }
      setTimeout(() => {
        this.countdown = this.countdown - 1;
        this.timer();
      }, 1000);
    },

    edit_disabled(ref) {
      this.$refs[ref].change_form_disabled();
    },

    // 返回
    goBack() {
      this.$router.back();
    },
  },
};
</script>

<style lang="scss" scoped>
.title_text {
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 16px;
  color: #333333;
  line-height: 22px;
  text-align: left;
  font-style: normal;
}

.title_content {
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 16px;
  color: #333333;
  line-height: 22px;
  text-align: left;
  font-style: normal;
  margin: 20px 0;
}

.line_ {
  border: 3px solid #f3f3f3;
  margin: 20px 0;
}

.bottom_box {
  margin-top: 20px;
}

.introduce_box {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #e40080;
  line-height: 22px;
  text-align: left;
  font-style: normal;
  margin-right: 50px;
  cursor: pointer;
}

/deep/ .el-form-item__content {
  width: 80%;
}

/deep/ .el-cascader {
  width: 100%;
}

/deep/ .el-row {
  display: flex;
  align-items: center;
}

/deep/ .el-dialog__body {
  //height: 600px !important;
  overflow: auto;
}

.statusBox {
  width: 749px;
  height: 100px;
  background: rgba(250, 173, 20, 0.1);
  border-radius: 18px;
  font-family: PingFangSC, PingFang SC;
  margin: 20px auto 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.statusBox_text {
  width: 520px;
  line-height: 24px;
  text-align: center;
  font-weight: 400;
  font-size: 14px;
}

.status0 {
  background: rgba(102, 102, 102, 0.1);
  border-radius: 18px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #444444;
  line-height: 22px;
  text-align: center;
  font-style: normal;
}

.status1 {
  background: rgba(250, 173, 20, 0.1);
  color: #faad14;
}

.status2 {
  background: rgba(82, 196, 26, 0.1);
  color: #52c41a;
}

.status3 {
  background: rgba(255, 77, 79, 0.1);
  color: #ff0000;
}

.footer {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}

/deep/ .el-tabs__nav-scroll {
  display: flex;
  justify-content: center;
}

/deep/ .el-tabs__nav-wrap::after {
  height: 1px;
  background-color: #eee;
}

/deep/ .el-tabs__header {
  //padding: 20px 0;
  margin: 0;
}

.searchBtnBox {
  margin-bottom: 20px;
}

.paginationbox {
  width: 100%;
  //position: absolute;
  bottom: 30px;
  left: 0;
}

.selitem {
  width: 100%;
}

.search-btn:hover {
  background: #e40080;
}

.search-btn:active {
  background: #e40080;
}

.content {
  padding-bottom: 40px;

  .main-title {
    margin-top: 40px;
    margin-bottom: 35px;
  }
}

/deep/ .el-dialog__footer {
  text-align: center;
}
</style>

